/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// import * as AppPropTypes from '../../lib/PropTypes';
//
import TimeSincePosted from './TimeSincePosted';
import TwitterIcon from '../icons/socials/TwitterSVG';
import styles from '../../../styles/partials/twitter.scss';

const propTypes = {
    item: PropTypes.object.isRequired, //eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const Twitter = ({ item, className }) => {
    const hashtag = text => {
        const twitteredText = text.replace(/#(\w+)/g, '<em style="color: #0d7d6d">#$1</em>');
        return twitteredText;
    };

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.background}>
                <div className={styles.inner}>
                    <div className={styles.icon}>
                        <TwitterIcon classname={styles.twitter} />
                    </div>
                    <div className={styles.user}>
                        <img src={item.avatar} className={styles.avatar} alt="a" />
                        <div className={styles.information}>
                            <div className={styles.username}>@{item.author}</div>
                            <TimeSincePosted date={item.date} className={styles.date} />
                        </div>
                    </div>
                    <div className={styles.content}>
                        {/* eslint-disable-next-line */}
                        <div dangerouslySetInnerHTML={{ __html: hashtag(item.text) }} />
                    </div>
                </div>
            </div>
        </div>
    );
};

Twitter.propTypes = propTypes;
Twitter.defaultProps = defaultProps;

export default Twitter;
